export default __webpack_public_path__ + "static/media/laval14.fa7bb424.jpg";